export default __webpack_public_path__ + "static/N0276-ae28034d72d2766dd2fa966bd28d8759.png";